import { siteInfo } from '@/mocks/comics';
import JsonLd from '@/components/feature/JsonLd';

export default function FAQSection() {
  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: siteInfo.faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <JsonLd data={faqJsonLd} />
      <section className="py-12 md:py-16 bg-background-50">
        <div className="max-w-[900px] mx-auto px-4 md:px-6">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              常见问题
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              关于韩漫画网，您可能想知道的
            </p>
          </div>
          <div className="space-y-3">
            {siteInfo.faqs.map((faq, index) => (
              <details
                key={index}
                className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
              >
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100/70 transition-colors">
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </h3>
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform shrink-0"></i>
                </summary>
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}